// extracted by mini-css-extract-plugin
export default {"menu_btn":"MenuBtn_menu_btn__gbSq+","menu":"MenuBtn_menu__qMoVQ","open":"MenuBtn_open__eSgFD","close":"MenuBtn_close__7BQgu"};